// extracted by mini-css-extract-plugin
export var acceptButton = "_2e-5";
export var fullContent = "_2e-4";
export var link = "_2e-6";
export var linkIcon = "_2e-7";
export var sideContent = "_2e-3";
export var sideImage = "_2e-2";
export var sideImageWrapper = "_2e-1";
export var splitLayout = "_2e-0";